// --------------------------------------------------------
// ERROR AREA - ErrorArea
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Alert from '@mui/material/Alert'
import React from 'react'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ERROR AREA INTERFACE
// --------------------------------------------------------

interface IErrorArea{
    errorList: any[];
    onCloseAction: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ErrorArea = ({errorList = [], onCloseAction = undefined}:IErrorArea) => {
  // --------------------------------------------------------
  // ERROR AREA PRIVATE DECLARATIONS
  // --------------------------------------------------------
  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
    {errorList.map(error=>{
        return <Alert severity="error"  variant="filled" onClose={onCloseAction} style={{ marginBottom: 5 }}>{error.message}</Alert>
    })}
    </>
  )
  // --------------------------------------------------------
}

export default ErrorArea